import { UserPreferenceKey, type UserPreferences } from '../types';

type RoleTaxonomyPreference = NonNullable<
  UserPreferences[UserPreferenceKey.Taxonomies]
>['role'];

/** The page's role filter carries the taxonomy version; the saved choice keeps it in `roleTaxonomyVersion`. */
const withoutVersion = (
  role: RoleTaxonomyPreference
): RoleTaxonomyPreference => {
  if (typeof role !== 'object' || role === null) return role;
  const { version: _version, ...selection } = role;
  return selection;
};

/**
 * Normalize semantically equivalent representations so diffs only reflect true differences.
 * Example: Taxonomies 'adaptive' vs { default: true } should be treated the same.
 */
export function normalizePreferencesForDiff(
  preferences: UserPreferences
): UserPreferences {
  const cloned = JSON.parse(JSON.stringify(preferences)) as UserPreferences;

  // Only compare role and skill inside the taxonomies key; ignore any effective* fields
  const taxonomies = cloned[UserPreferenceKey.Taxonomies];
  if (taxonomies) {
    const { role, skill, activity } = taxonomies;
    cloned[UserPreferenceKey.Taxonomies] = {
      role: withoutVersion(role),
      skill,
      activity,
    };
  }

  return cloned;
}
